import { Link } from 'react-router-dom';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';
import { featuredChefs } from '../../../mocks/chefs';

export default function RecommendedChefs() {
  // Get the first chef from the featured chefs list
  const recommendedChef = featuredChefs[0];

  // If no recommended chef is available, don't render the section
  if (!recommendedChef) {
    return null;
  }

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            <span className="text-emerald-600">RECOMMENDED</span> CHEFS
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our top-rated and most trusted private chefs, handpicked for their exceptional 
            culinary skills and outstanding service across South Africa.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <Card className="overflow-hidden">
              <div className="relative">
                <img 
                  src={recommendedChef.image}
                  alt={`${recommendedChef.name} - Private Chef ${recommendedChef.location}`}
                  className="w-full h-80 object-cover object-top"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-4 py-2 bg-emerald-600 text-white rounded-full text-sm font-bold">
                    RECOMMENDED CHEF
                  </span>
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{recommendedChef.name}</h3>
                <p className="text-emerald-600 font-semibold mb-3 text-lg">{recommendedChef.specialty}</p>
                <p className="text-gray-600 mb-4 flex items-center">
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-map-pin-line text-lg"></i>
                  </div>
                  {recommendedChef.location}
                </p>
                
                <p className="text-gray-700 mb-6 leading-relaxed">
                  {recommendedChef.description}
                </p>
                
                <div className="flex flex-wrap gap-2 mb-6">
                  {recommendedChef.cuisines.slice(0, 3).map((cuisine, index) => (
                    <span key={index} className="px-3 py-1 bg-emerald-100 text-emerald-800 rounded-md text-sm font-medium">
                      {cuisine}
                    </span>
                  ))}
                </div>
                
                <div className="flex justify-center">
                  <a 
                    href="https://gordonscreations.co.za/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-full"
                  >
                    <Button className="w-full whitespace-nowrap">
                      Private Chef Johannesburg
                    </Button>
                  </a>
                </div>
              </div>
            </Card>
          </div>

          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Why Choose Our Recommended Chefs?</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-shield-check-line text-emerald-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Verified Excellence</h4>
                    <p className="text-gray-600">All recommended chefs undergo rigorous vetting and maintain consistently high standards.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-star-line text-emerald-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Outstanding Reviews</h4>
                    <p className="text-gray-600">Consistently rated as top performers by clients across South Africa.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-award-line text-emerald-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Professional Experience</h4>
                    <p className="text-gray-600">Years of experience in fine dining, corporate catering, and private events.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-heart-line text-emerald-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Personalized Service</h4>
                    <p className="text-gray-600">Tailored menus and exceptional attention to dietary requirements and preferences.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-emerald-50 p-6 rounded-lg">
              <h4 className="font-bold text-gray-900 mb-2">Book with Confidence</h4>
              <p className="text-gray-700 text-sm">
                Our recommended chefs are available for private dining, corporate events, 
                special occasions, and cooking classes. Contact them directly for personalized quotes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
